import React from "react";
import { FiPlus } from "react-icons/fi";
import { Link } from "react-router-dom";

const StateHeader = ({ permission }) => {
   const IsAdmin = localStorage.getItem("IsAdmin");

  const canAdd =
    IsAdmin === "yes" || (IsAdmin === "no" && permission?.pf_add === 1);

  return (
    <>
      <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
        {canAdd && (
          <Link to="/master/add-state" className="btn btn-primary">
            <FiPlus size={16} className="me-2" />
            <span>Create State</span>
          </Link>
        )}
      </div>
    </>
  );
};

export default StateHeader;
